import { createElement, memo, useEffect } from '@max/max';
import Image from '@hfe/max-image';
import './index.scss';
import { MORE_MV } from '../../utils/constant';
const MyComponent = (props) => {
    const { showMoreImage, mvReport } = props;
    useEffect(() => {
        mvReport && mvReport(MORE_MV, {
            valLab: {}
        });
    }, []);
    return <Image className="deal-more-btn" source={{
            uri: showMoreImage
        }}/>;
};
export default memo(MyComponent);
